import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DeleteCompaniesPayload } from '@/api/v4/organization.api';
import { deleteCompanies as deleteCompaniesAPI } from '@/api/v4/organization.api';
import { QueryKey } from '@/config/query-client';

export const useDeleteCompanies = () => {
  const queryClient = useQueryClient();

  const deleteCompaniesMutation = useMutation({
    mutationFn: deleteCompaniesAPI,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.CompaniesKpi] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.Companies] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyOptionsCount],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompaniesStatistics],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  const deleteCompanies = (payload: DeleteCompaniesPayload) =>
    deleteCompaniesMutation.mutateAsync(payload);

  return {
    deleteCompanies,
    isLoading: deleteCompaniesMutation.isPending,
    isError: deleteCompaniesMutation.isError,
  };
};
